import { Component, OnInit } from '@angular/core';
import { mergeMap, tap } from "rxjs/operators";
import { Checklist } from "../../../classes/checklist";
import { ChecklistCategoryService } from '../../../services/checklistCategory';
import { HttpErrorResponse } from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {ChecklistService} from "../../../services/checklist";
import {ChecklistSubCategory} from "../../../classes/checklistSubCategory";
import {ChecklistCategory} from "../../../classes/checklistCategory";
import {ChecklistSubCategoryService} from "../../../services/checklistSubCategory";

@Component({
  selector: 'app-checklist-create',
  templateUrl: './checklist-subcategory-create.component.html',
  styleUrls: ['./checklist-subcategory-create.component.css']
})
export class ChecklistSubcategoryCreateComponent implements OnInit {

  checklist = new Checklist();
  checklistCategory = new ChecklistCategory();
  checklistSubCategory = new ChecklistSubCategory();
  checklistSubCategoryCreationResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checklistService: ChecklistService,
              private checklistCategoryService: ChecklistCategoryService,
              private checklistSubCategoryService: ChecklistSubCategoryService) { }

  ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
          this.checklistCategoryService.getByID(params.get('id'))
              .pipe(
                  tap((checklistCategory: any) => {
                      this.checklistCategory = checklistCategory;
                      this.checklistSubCategory.fk_id_checklist_category = this.checklistCategory.id_checklist_category;
                  }),
                  mergeMap(() => this.checklistService.getByID((this.checklistCategory.fk_id_checklist as number).toString()))
              )
              .subscribe({
                  next: (checklist: any) => {
                      this.checklist = checklist;
                  },
                  error: (err: HttpErrorResponse) => {
                      console.log(err);
                  }
              });
      });
  }

  onSubmit() {
    this.checklistSubCategoryService.create(this.checklistSubCategory)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist-category/' + this.checklistCategory.id_checklist_category]);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistSubCategoryCreationResult = false;
          console.log(err);
        }
      });
  }

}
